module.exports = __webpack_public_path__ + "img/hm.b966d328.svg";